<template>
  <div class="content-container flex-column">
    <div class="grid-x toolbar fixed">
      <div class="cell auto">
        <h4 class="no-margin toolbar-title">Ny Kunde</h4>
      </div>

      <div class="cell shrink" v-if="$store.getters.isFormSubmittable">
        <a href="javascript:;" @click="onKundeCancel()" class="button primary transparent">Lukk redigering</a>
        <a href="javascript:;" @click="onSaveButtonClick()" class="button primary">Lagre endringer</a>
      </div>

      <div class="cell shrink" v-if="$store.getters.isFormProcessing">
        <a href="javascript:;" class="button primary transparent">Lukk redigering</a>
        <a href="javascript:;" class="button primary loading">Lagrer...<span class="loader-spinner"></span></a>
      </div>

      <div class="cell shrink" v-if="$store.getters.isFormLoading">
        <a href="javascript:;" @click="onKundeCancel()" class="button primary transparent">Lukk redigering</a>
        <a href="javascript:;" class="button primary" disabled>Lagre<span class="show-for-medium"> endringer</span></a>
      </div>
    </div>

    <KundeCardForm v-on:kunde_form_saved="onKundeSaved"/>
  </div>
</template>

<script>
import KundeCardForm from './KundeCardForm'
import bus from '@/plugins/event-bus'

export default {
  name: 'KundeCardAdd',
  components: {
    KundeCardForm
  },
  methods: {
    onKundeSaved: function (data) {
      this.$helpers.showSuccessAlert('Kunde er lagret')
      this.$router.push({ name: 'KundeCard', params: {kunde_id: data.Kundenr} })
    },
    onKundeCancel: function () {
      this.$router.go(-1)
    },
    onSaveButtonClick: function () {
      bus.$emit('kunde-form-submit')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/KundeCardAdd.vue